export const getHeatMapOpacity = (
  rawdata: any,
  compareKey: string,
  minOpacity: number = 0,
  maxOpacity: number = 1
) => {
  if (!Array.isArray(rawdata) || !compareKey) {
    return [];
  }

  if (maxOpacity <= minOpacity || maxOpacity > 1) {
    maxOpacity = 1;
  }
  if (minOpacity >= maxOpacity || minOpacity < 0) {
    minOpacity = 0;
  }

  const min = Math.min(...rawdata.map((i) => i[compareKey]));
  const max = Math.max(...rawdata.map((i) => i[compareKey]));
  const gap = max - min;
  const range = maxOpacity - minOpacity;

  return rawdata.map((i) => {
    const diff = (i[compareKey] - min) / gap;
    const opacity = diff * range + minOpacity;

    return {
      ...i,
      opacity,
    };
  });
};
